/** Create URL-friendly strings */
export const slugify = (text: string) => {
	return text
		.toLowerCase()
		.replace(/ /g, '-')
		.replace(/[^\w-]+/g, '');
};
